import { Color, DefaultValue, Spacing } from '@billy/design-system'
import { css } from '@emotion/core'
import styled from '@emotion/styled'
import { transparentize } from 'polished'

export const InfiniteTableWrapper = styled.div`
  border-radius: ${DefaultValue.BorderRadius};
  position: relative;
`

export const InfiniteTableComponent = styled.table`
  width: 100%;
  position: relative;
  z-index: 0;

  thead {
    padding-bottom: 12px;
    color: ${Color.Black};
  }

  tr {
    padding-right: ${Spacing.S32};
    padding-left: ${Spacing.S32};
    border-bottom: 1px solid ${Color.Grey150};
    position: relative;

    &.total {
      border-top: 2px solid ${Color.Grey150};

      td {
        font-weight: bold;
      }
    }
  }

  td {
    padding-top: ${Spacing.S4};
    padding-bottom: ${Spacing.S4};
    white-space: nowrap;
  }

  tbody tr.hoverable:hover {
    background: ${transparentize(0.75, Color.Grey300)};
    cursor: pointer;
  }

  thead {
    tr {
      padding-top: ${Spacing.S16};
      padding-bottom: ${Spacing.S16};
      border-radius: ${DefaultValue.BorderRadius} ${DefaultValue.BorderRadius} 0 0;
      background-color: ${Color.White};
      box-shadow: 0 1px 3px ${transparentize(0.8, Color.Grey500)};
    }
  }

  tbody {
    background-color: ${Color.White};
  }

  &.stickyHeader {
    thead {
      tr {
        position: sticky;
        top: 0;
        z-index: 2;
        background-color: ${Color.White};
      }
    }
  }

  &.selectable {
    tr {
      padding-left: 35px;
    }
  }
`

export const rowStyles = css`
  display: grid;
  grid-template-rows: auto 1fr auto;
  width: 100%;
  border-collapse: collapse;
`
